import { render } from "./Tag.vue?vue&type=template&id=79b586e4&scoped=true&ts=true"
import script from "./Tag.ts?vue&type=script&lang=ts&external"
export * from "./Tag.ts?vue&type=script&lang=ts&external"

import "./Tag.scss?vue&type=style&index=0&id=79b586e4&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b586e4"]])

export default __exports__